import { APPOINTMENT_STATUS } from 'app/pages/Appointments/constants';

import type { ApiAppointment, PrintStatus } from '../types';

export const PRINT_STATUS_LABELS: Record<PrintStatus, string> = {
  BOOKED: 'Booked',
  ATTENDED: 'Attended',
  NOT_ATTENDED: 'Not attended',
  CANCELLED: 'Cancelled',
  NEEDS_OUTCOME: 'Needs outcome',
};

/**
 * Maps an API status onto the printed status. "Needs outcome" is not an API status: the screen
 * derives it as a booked appointment whose start time has passed (see AppointmentActions), and the
 * sheet uses the same rule.
 */
export function printStatus(
  appointment: Pick<ApiAppointment, 'status' | 'startDate'>,
  now: Date
): PrintStatus {
  switch (appointment.status) {
    case APPOINTMENT_STATUS.CANCELLED:
      return 'CANCELLED';
    case APPOINTMENT_STATUS.ATTENDED:
      return 'ATTENDED';
    case APPOINTMENT_STATUS.NOT_ATTENDED:
      return 'NOT_ATTENDED';
    default: {
      // The list endpoints exclude drafted appointments, so anything else is a booking.
      const hasStarted = new Date(appointment.startDate).getTime() < now.getTime();
      return hasStarted ? 'NEEDS_OUTCOME' : 'BOOKED';
    }
  }
}
